<div>
  <img src="../../assets/about-us/Banner 3.png" class="img-fluid" alt="Responsive image">
</div>

<div class="page-body">
  <div class="container pt-1">
    <img src="../../assets/about-us/Placeholder3.png" class="img-fluid" alt="Responsive image"/>
  </div>
 </div>
